import { render } from "./NotreRevue.vue?vue&type=template&id=6981fa86&scoped=true&ts=true"
import script from "./NotreRevue.vue?vue&type=script&lang=ts"
export * from "./NotreRevue.vue?vue&type=script&lang=ts"

import "./NotreRevue.vue?vue&type=style&index=0&id=6981fa86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6981fa86"]])

export default __exports__